import { mapState, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'

const appdata = {
  directives: {
    mask
  },
  data: () => ({
    phone_mask: '(##) ##### ####',
    cep_mask: '#####-###',
    cpf_mask: '###.###.###-##'
  }),
  computed: {
    ...mapState('router', {
      routerPath: 'path'
    }),
    ...mapState('socket', {
      socketInfo: 'socket',
      externalApi: 'external_api'
    }),
    ...mapGetters({
      app_data: 'getAppData',
      get_options: 'getOptions',
      login_data: 'loginData',
      user_data: 'userData',
      lang: 'getLanguage',
      get_interface: 'getInterface',
      get_data: 'getData',
      get_global: 'getGlobal',
      tableheaders: 'getTableHeaders',
      is_mobile: 'isMobile',
      permissions: 'userPermissions',
      preferences: 'getPreferences'
    })
  },
  methods: {
    fullDataReload () {
      this.$store.dispatch('socket/CUSTOM_DATA', this.get_global.filters)
      /* if (this.filters) {
        this.$store.dispatch('socket/CUSTOM_DATA', this.get_global.filters)
      } else {
        this.$store.dispatch('loadData')
      } */
    }
  }
}

export default appdata
